export { registerIconLibrary, unregisterIconLibrary } from '../components/ui/icon/library';
